export const theme = {
  colors: {
    text: '#0F0',
    background: '#fff'
  }
};
